import React from 'react';

import { FaTimesCircle, FaSync, FaCheckCircle, FaInfo } from 'react-icons/fa';

const Message = ({ children, level }) => {
  let levelClasses = 'border-gray-400';
  if (level === 'info') levelClasses = 'border-blue-500 bg-blue-100 text-blue-500';
  if (level === 'loading') levelClasses = 'border-yellow-500 bg-yellow-50 text-yellow-500';
  if (level === 'error') levelClasses = 'border-red-500 bg-red-100 text-red-500';
  if (level === 'success') levelClasses = 'border-green-500 bg-green-100 text-green-500';
  return (
    <div className={`p-4 shadow-lg border w-1/2 flex items-center justify-center space-x-4 ${levelClasses}`}>
      {/* {level === 'info' && <FaInfo className="mr-2" />}
      {level === 'success' && <FaCheckCircle className="mr-2" />}
      {level === 'error' && <FaTimesCircle className="mr-2" />} */}
      {level === 'loading' && <FaSync className="mr-2 animate-spin-slow" />}
      {children}
    </div>
  );
};

export default Message;
